<div class="group" [class.active]="active" [title]="title">
  <div class="label">{{ label }}</div>
  @if (counter >= 0) {
    <div class="counter">{{ counter }}</div>
  }
</div>
